import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Register from "../MembershipRegistration/corporate_register.js";

// import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor.js";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Dashboard = () => {
  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#e8e8e8",
        height: "100%",
        minHeight: "100vh",
        width: "100vw",
      }}
    >
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
        }}
      >
        <DrawerHeader />

        <Register />
      </Box>
    </Box>
  );
};

export default Dashboard;
